import angular from 'angular';
import ngAnimate from 'angular-animate'
import ngAria from 'angular-aria'
import ngResource from 'angular-resource'
import pascalprechtTranslate from 'angular-translate'
import angularTranslateLoader from 'angular-translate-loader-static-files'
import uiRouter from 'angular-ui-router'
import LocalStorageModule from 'angular-local-storage'
require('sp-nggallery/src/js/ngGallery.js')
require('spin.js')
require('angular-spinner')
require('sp-nggallery/src/css/ngGallery.css')
require('bootstrap/dist/css/bootstrap.css')
require('font-awesome/css/font-awesome.css')
import jsPDF from 'jspdf';
window.jsPDF = jsPDF
require('jspdf-autotable')
import angularSvgRoundProgressbar from 'angular-svg-round-progressbar'
const MODULE_NAME = 'ObrasGovMapApp';

require('./scripts/modules')

angular.module(MODULE_NAME, [uiRouter, ngResource, LocalStorageModule, ngAria, 'soTranslate',
'jkuri.gallery',
'angularSpinner', pascalprechtTranslate]);
export default MODULE_NAME;

require('./scripts/values')
require('./scripts/constants')
require('./scripts/directives')
require('./scripts/factories')
require('./scripts/services')
require('./scripts/configs')
require('./scripts/controllers')
require('./scripts/helpers')

require('inputmask');
require('bootstrap-datepicker/dist/css/bootstrap-datepicker3.css')
require('bootstrap-datepicker/dist/js/bootstrap-datepicker.js')
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.pt-BR.js')

require('../style/colors.css')
require('../style/functions.css')
require('../style/obrasgovmap.css')



// WEBPACK FOOTER //
// ./src/app/app.js